(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultQuizQuestionsController', DefaultQuizQuestionsController)

	/** @ngInject */
	function DefaultQuizQuestionsController($timeout, $state, HelperService, LeadService) {
		const vm = this;

		vm.getPaginatedQuestions = (perPage, page) => {
			--page;
			let overlap = (vm.questions.length % perPage == 0 ? 0 : 1);
			let numberOfPages = parseInt((vm.questions.length / perPage) + overlap);

			let returnObj = {
				questions: vm.questions.slice(page * perPage, (page + 1) * perPage),
				numberOfPages
			}

			return returnObj;
		}

		vm.goToNextPage = () => {
			vm.invalidQuestion = null;

			let currentQuestions = vm.getPaginatedQuestions(vm.questionsPerPage, vm.currentPage).questions.map(el => el.Number);
			let currentAnswers = angular.copy(vm.quizAnswers);

			let validated = validateAnswers(currentQuestions, currentAnswers);

			if (validated.includes(false)) {
				let invalidQuestion = currentQuestions[validated.findIndex(el => el == false)];

				$timeout(() => {
					vm.invalidQuestion = invalidQuestion;
					HelperService.scrollTo(`.question-card-${invalidQuestion}`);
				}, 100)

				return
			}

			if (vm.currentPage < vm.getPaginatedQuestions(vm.questionsPerPage, vm.currentPage).numberOfPages) {
				HelperService.startLoading(".app-body", "", true);

				$timeout(() => {
					HelperService.scrollTo(".let-start");
					vm.currentPage++;
					HelperService.stopLoading(".app-body");
				}, 500)
			}
		}

		vm.goToPrevPage = () => vm.currentPage--;

		vm.endQuiz = () => {
			HelperService.startLoading(".app-body", "", true);

			let result = calculateResult();
			result = result.map(el => parseInt(el));

			let leadResult = {
				Name: LeadService.getAstronautName(),
				Dummy: JSON.stringify(LeadService.getAstronautParts()),
				Result: JSON.stringify(result)
			}

			saveLeadResult(leadResult);
		}

		vm.removeInvalidQuestion = (questionNumber, isChecked) => {
			if (vm.invalidQuestion) {
				if (questionNumber == vm.invalidQuestion && isChecked == true)
					vm.invalidQuestion = null;
				else
					vm.goToNextPage();
			}
		}

		vm.getCourse = (Id) => vm.programs.find(el => el.Id == Id);

		init();

		function saveLeadResult(leadResult) {
			LeadService
				.saveLeadResult(leadResult)
				.then(
					success => {
						if (success.Success) {
							$state.go('default.quiz-result', { resultHash: success.Hash });
							HelperService.stopLoading(".app-body");
						} else {
							HelperService.errorCallback(success);
							HelperService.stopLoading(".app-body");
						}

					},
					error => {
						HelperService.errorCallback(error);
						HelperService.stopLoading(".app-body");
					}
				)
		}

		function validateAnswers(currentQuestions, currentAnswers) {
			if (!currentAnswers) return false;

			let verify = currentQuestions.map(question => {
				if (!currentAnswers[question]) return false

				return true;
			});

			return verify;
		}

		function calculateResult() {
			vm.goToNextPage();

			let answers = angular.copy(vm.quizAnswers);
			let currentResult = [];

			if (answers[1] != 4)
				currentResult.push(1)
			else
				currentResult.push(0)

			if (answers[2] != 5)
				currentResult.push(2)
			else
				currentResult.push(0)

			if (answers[3] != 4)
				currentResult.push(2)
			else
				currentResult.push(0)

			if (answers[4] != 4)
				currentResult.push(4)
			else
				currentResult.push(0)

			if (answers[5] == 1)
				currentResult.push(4, 3)
			else if (answers[5] == 2)
				currentResult.push(3, 2)
			else if (answers[5] == 3)
				currentResult.push(2)
			else if (answers[5] == 4)
				currentResult.push(1)

			if (answers[6] == 1)
				currentResult.push(4, 3)
			else if (answers[6] == 2)
				currentResult.push(3)
			else if (answers[6] == 3)
				currentResult.push(1)
			else if (answers[6] == 4)
				currentResult.push(2)

			if (answers[7] == 1)
				currentResult.push(2)
			else if (answers[7] == 2)
				currentResult.push(4, 3)
			else if (answers[7] == 3)
				currentResult.push(4)
			else if (answers[7] == 4)
				currentResult.push(1)

			if (answers[8] == 1)
				currentResult.push(2)
			else if (answers[8] == 2)
				currentResult.push(3, 2)
			else if (answers[8] == 3)
				currentResult.push(1)
			else if (answers[8] == 4)
				currentResult.push(4)

			if (answers[9] == 1)
				currentResult.push(2)
			else if (answers[9] == 2)
				currentResult.push(3)
			else if (answers[9] == 3)
				currentResult.push(1)
			else if (answers[9] == 4)
				currentResult.push(4)

			let mostFrequent = getFrequentResult(currentResult);

			vm.endedQuiz = true;

			return mostFrequent;
		}

		function getFrequentResult(inputedArray) {
			let object = {};
			let result = [];

			inputedArray.forEach(item => {
				if (!object[item] && item != 0) object[item] = 0;

				object[item] += 1;
			})

			for (let prop in object)
				if (object[prop] >= 2) result.push(prop);

			return result;
		}

		function validateQuizStep() {
			let leadData = LeadService.getLeadData();
			let astronautName = LeadService.getAstronautName();
			let astronautParts = LeadService.getAstronautParts();

			if (!leadData || !astronautName || !astronautParts)
				$state.go("default.quiz-intro")
		}

		function initVars() {
			vm.currentPage = 1;
			vm.questionsPerPage = 2;
			vm.quizAnswers = {};
			vm.invalidQuestion == null;
			vm.astronautName = LeadService.getAstronautName();

			vm.programs = [
				{
					Name: 'Financial Education',
					Id: 1
				}, {
					Name: 'Emotional Intelligence',
					Id: 2
				}, {
					Name: 'Logical Thinking',
					Id: 3
				}, {
					Name: 'Digital Mindset',
					Id: 4
				}
			]

			vm.selectedDummyParts = LeadService.getAstronautParts();

			vm.questions = [
				{
					Number: 1,
					Question: "Selecione abaixo o comportamento que o seu filho costuma apresentar quando vai às compras com você:",
					Answers: [{
						Answer: "Se frustra quando não adquire o que quer",
						Value: 1
					}, {
						Answer: "Não sabe o que quer.",
						Value: 2
					}, {
						Answer: "Quer comprar tudo o que vê.",
						Value: 3
					}, {
						Answer: "Nenhum dos comportamentos citados.",
						Value: 4
					}],
					Color: 'red'
				}, {
					Number: 2,
					Question: "Selecione abaixo o comportamento que o seu filho apresenta em relações interpessoais:",
					Answers: [{
						Answer: "Tem dificuldade para compartilhar.",
						Value: 1
					}, {
						Answer: "Destrói coisas de propósito.",
						Value: 2
					}, {
						Answer: "Tem dificuldade para nomear seus sentimentos.",
						Value: 3
					}, {
						Answer: "Se irrita com facilidade.",
						Value: 4
					}, {
						Answer: "Nenhum dos comportamentos citados.",
						Value: 5
					}],
					Color: 'green'
				}, {
					Number: 3,
					Question: "Selecione abaixo o comportamento que o seu filho apresenta em momentos de aprendizado:",
					Answers: [{
						Answer: "Dificuldade de acompanhar aulas de matemática.",
						Value: 1
					}, {
						Answer: "Dificuldade de concentração.",
						Value: 2
					}, {
						Answer: "Não se interessa por atividades que envolvam raciocínio.",
						Value: 3
					}, {
						Answer: "Nenhum dos comportamentos.",
						Value: 4
					}],
					Color: 'red'
				}, {
					Number: 4,
					Question: "Selecione abaixo o comportamento que o seu filho apresenta quando está em contato com a tecnologia (smartphone, computador, tablet, videogame…):",
					Answers: [{
						Answer: "Fica o tempo todo só em redes sociais e games.",
						Value: 1
					}, {
						Answer: "Não consegue diferenciar conteúdos bons e ruins.",
						Value: 2
					}, {
						Answer: "Não se interessa por aprender as potencialidades e possibilidades que essas ferramentas oferecem.",
						Value: 3
					}, {
						Answer: "Nenhum dos comportamentos acima.",
						Value: 4
					}],
					Color: 'green'
				}, {
					Number: 5,
					Question: "Na sua opinião, qual será a competência mais importante para o ser humano no futuro?",
					Answers: [{
						Answer: "Saber programar computadores e entender como funciona o mundo digital (internet).",
						Value: 1
					}, {
						Answer: "Ter pensamento crítico.",
						Value: 2
					}, {
						Answer: "Ter empatia.",
						Value: 3
					}, {
						Answer: "Compreender como usar o dinheiro.",
						Value: 4
					}],
					Color: 'red'
				}, {
					Number: 6,
					Question: "O que você pensa sobre o mundo em um futuro próximo?",
					Answers: [{
						Answer: "Dominado pela tecnologia, mas com emprego para aqueles que entendem o mundo digital e interagem com ele de forma natural.",
						Value: 1
					}, {
						Answer: "Dominado pela tecnologia, mas protagonizado pelas pessoas que dominam o pensamento lógico-matemático.",
						Value: 2
					}, {
						Answer: "Quem souber administrar dinheiro vai se dar bem.",
						Value: 3
					}, {
						Answer: "Quem souber dominar as habilidades humanas vai se dar bem.",
						Value: 4
					}],
					Color: 'green'
				}, {
					Number: 7,
					Question: "Eu quero que as crianças da minha família:",
					Answers: [{
						Answer: "Melhorem suas habilidades sociais.",
						Value: 1
					}, {
						Answer: "Entendam como funciona um computador.",
						Value: 2
					}, {
						Answer: "Protejam-se ao navegar no mundo digital.",
						Value: 3
					}, {
						Answer: "Preparem-se para gerir seu próprio dinheiro.",
						Value: 4
					}],
					Color: 'red'
				}, {
					Number: 8,
					Question: "Qual a sua expectativa quando seu filho usa a internet?",
					Answers: [{
						Answer: "Que ele saiba interagir com outras pessoas.",
						Value: 1
					}, {
						Answer: "Que ele brinque com atividades que desenvolvam criatividade.",
						Value: 2
					}, {
						Answer: "Que ele aprenda sobre sustentabilidade e economia.",
						Value: 3
					}, {
						Answer: "Que ele aprenda a usar ferramentas tecnológicas e digitais.",
						Value: 4
					}],
					Color: 'green'
				}, {
					Number: 9,
					Question: "Neste momento, quero que meu filho desenvolva/exercite a capacidade de:",
					Answers: [{
						Answer: "Se relacionar bem com outras pessoas.",
						Value: 1
					}, {
						Answer: "Relacionar problemas e soluções.",
						Value: 2
					}, {
						Answer: "Usar sua mesada com consciência.",
						Value: 3
					}, {
						Answer: "Usar a internet com autonomia.",
						Value: 4
					}],
					Color: 'red'
				}
			]
		}

		function init() {
			initVars();
			validateQuizStep();

		}

	}
}());